import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import Footer from 'modules/core/components/Sidepanel/Footer'

import { ExpenseFormValues } from 'modules/expenses/components/expenses/Detail/_Form/Expense/new/form/form'
import { type MileageFormValues } from 'modules/expenses/components/expenses/Detail/_Form/Mileage/new/form/form'
import { PerDiemFormValues } from 'modules/expenses/components/expenses/Detail/_Form/PerDiem/new/form/form'
import CreateExpenseButton from 'modules/expenses/components/expenses/Form/Buttons/CreateExpenseButton'
import SendExpensableForApprovalButton from 'modules/expenses/components/expenses/Form/Buttons/SendExpensableForApprovalButton'
import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { SignableOrganizationPerCountry } from 'modules/expenses/hooks/useTaxAgencyHomologations'

interface FooterActionsProps {
  formType: ExpensesEntitiesExpensableResourceTypeEnum
  customizationFields: CustomizationField[]
  taxAgencyOrganization: SignableOrganizationPerCountry | null
  onClose: () => void
  groupId?: string
}

const CreateExpenseFooterActions = <
  T extends ExpenseFormValues | PerDiemFormValues | MileageFormValues
>({
  formType,
  customizationFields,
  taxAgencyOrganization,
  onClose,
  groupId,
}: FooterActionsProps) => {
  const {
    trigger,
    getValues,
    formState: { isValid },
  } = useFormContext<T>()

  const [isCreating, setCreating] = useState(false)
  const [isSending, setSending] = useState(false)

  const formValues = getValues()

  if (!formValues) {
    return null
  }

  const isLoading = isCreating || isSending

  return (
    <Box position="sticky" style={{ bottom: '0' }}>
      <Footer
        content={
          <Box
            width="full"
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            paddingX="s8"
            gap="s8"
          >
            <CreateExpenseButton
              formType={formType}
              formValues={formValues}
              customizationFields={customizationFields}
              onClose={onClose}
              buttonType="secondary"
              useDraftLabel
              taxAgencyOrganization={taxAgencyOrganization}
              disabled={isLoading}
              onLoadingChange={setCreating}
            />
            {!groupId && (
              <SendExpensableForApprovalButton
                formType={formType}
                customizationFields={customizationFields}
                formValues={formValues}
                formValid={isValid}
                onClose={onClose}
                taxAgencyOrganization={taxAgencyOrganization}
                trigger={trigger}
                disabled={isLoading}
                onLoadingChange={setSending}
              />
            )}
          </Box>
        }
      />
    </Box>
  )
}

export default CreateExpenseFooterActions
